import React from 'react';

import { queryClient } from '@/src/lib/react-query/react-query';

import ManageAccessList, { MemberActionInput } from './ManageAccessList';

import { useAddFolderLibraryMember } from '../../../api/folders/addibraryFolderLMember';
import { useDeleteFolderLibraryMember } from '../../../api/folders/deleteLibraryFolderMember';
import {
  getLibraryFolderMembersQueryKey,
  useGetLibraryFolderMembers,
} from '../../../api/folders/getLibraryFolderMembers';

const FolderManageAccessList = ({ folderId, onClose }) => {
  const addLibraryMemberMutation = useAddFolderLibraryMember();
  const deleteLibraryMemberMutation = useDeleteFolderLibraryMember();
  const libraryMembersQuery = useGetLibraryFolderMembers({ folderId });

  const handleAdd = ({ memberId }: MemberActionInput) => {
    return addLibraryMemberMutation.mutateAsync({
      folderId,
      memberId,
    });
  };

  const handleDelete = ({ memberId }: MemberActionInput) => {
    return deleteLibraryMemberMutation.mutateAsync({
      folderId,
      memberId,
    });
  };

  return (
    <ManageAccessList
      onClose={onClose}
      onAdd={handleAdd}
      onDelete={handleDelete}
      libraryMembersQuery={libraryMembersQuery}
      onSaved={() =>
        queryClient.invalidateQueries({ queryKey: getLibraryFolderMembersQueryKey.list })
      }
    />
  );
};

export default FolderManageAccessList;
